/** Browser-context utilities shared by login routing behavior. */
export class DomUtil {

  /** Returns whether the page is running inside the browser extension iframe. */
  public static isExtension(): boolean {
    return DomUtil.isExtensionFrame(window.parent !== window, window.location.ancestorOrigins);
  }

  /** Identifies extension frames, treating unavailable or redacted ancestor origins as extension traffic. */
  public static isExtensionFrame(isFramed: boolean, ancestorOrigins: Pick<DOMStringList, 'item'> | undefined): boolean {
    const ancestorOrigin = ancestorOrigins?.item(0);

    return isFramed && (
      ancestorOrigins === undefined || // Preserve the fallback when the browser does not expose ancestor origins.
      ancestorOrigin === 'null' || // Preserve the fallback when referrer policy redacts the ancestor origin.
      ancestorOrigin === 'chrome-extension://heejmadlpimhgikldldieplegefeomkf'
    );
  }

  /** Returns whether extension traffic is entering through the main login route. */
  public static shouldRedirectExtensionLogin(pathname: string = window.location.pathname): boolean {
    return DomUtil.isExtension() && (pathname === '/login' || pathname === '/login/');
  }
}
